<template>
  <section>
    <ax-panel title="名片信息">
      <van-cell
        title="姓名"
        v-model="data.header.emplid_description"
      ></van-cell>
      <van-cell
        title="英文姓名"
        v-if="data.header.name_ac"
        v-model="data.header.name_ac"
      ></van-cell>
      <van-cell title="部门" v-model="data.header.dept_descr"></van-cell>
      <van-cell title="对外机构" v-model="data.header.qh_dept_descr"></van-cell>
      <van-cell
        title="部门英文名称"
        v-if="data.header.qh_dept_eng"
        v-model="data.header.qh_dept_eng"
      ></van-cell>
      <ax-fold>
        <van-cell
          title="职位"
          v-model="data.header.qh_external_posn"
        ></van-cell>
        <van-cell
          title="对外职位名称"
          v-model="data.header.qh_position_descr"
        ></van-cell>
        <van-cell
          title="岗位英文名称"
          v-if="data.header.name_ac"
          v-model="data.header.qh_position_eng"
        ></van-cell>
        <van-cell title="手机" v-model="data.header.emplid_phone"></van-cell>
        <van-cell
          title="固定电话"
          v-if="data.header.name_ac"
          v-model="data.header.phone1"
        ></van-cell>
        <van-cell
          title="传真"
          v-if="data.header.fax"
          v-model="data.header.fax"
        ></van-cell>
        <van-cell title="e-mail" v-model="data.header.email_addr"></van-cell>
        <van-cell
          title="地址"
          v-if="data.header.addresslong"
          v-model="data.header.addresslong"
        ></van-cell>
        <van-cell
          title="邮编"
          v-if="data.header.postal"
          v-model="data.header.postal"
        ></van-cell>
        <van-cell title="印刷数量">{{ data.header.qh_name_card }}盒</van-cell>
        <van-cell
          title="申请原因"
          v-model="data.header.comments_256"
        ></van-cell>
      </ax-fold>
    </ax-panel>
    <ax-panel title="备注">
      <van-cell title="部分办公地点">酒仙桥</van-cell>
      <van-cell title="总机">58781000</van-cell>
      <van-cell title="传真">58781000</van-cell>
      <van-cell title="地址">北京市朝阳区酒仙桥路6号院2号楼</van-cell>
      <van-cell title="邮编">100015</van-cell>
    </ax-panel>
    <ax-panel title="申请人信息">
      <van-cell title="姓名" :value="data.header.emplid_description"></van-cell>
      <van-cell title="邮箱">
        <a class="mail_a" :href="'mailto:' + data.header.email_addr">{{
          data.header.email_addr
        }}</a>
      </van-cell>
      <van-cell title="电话">
        <a class="link_a" :href="'tel:' + data.header.emplid_phone">{{
          data.header.emplid_phone
        }}</a>
      </van-cell>
      <van-cell title="部门" :value="data.header.dept_descr"></van-cell>
    </ax-panel>
  </section>
</template>

<script>
export default {
  props: ["data"],
};
</script>

<style></style>
